// Enum for bus stop modal types.
export const busStopModalType = Object.freeze({
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete'
});
